const c = {
  name: "Revenue",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,20.6C6.9,22.5,5.4,24,3.5,24S0,22.4,0,20.5c0-1.9,1.6-3.5,3.5-3.4c1.3,0,2.4,0.7,3,1.7l4.6-2.5
			C11,16.1,11,15.8,11,15.6c0-1.9,1.6-3.5,3.5-3.5c1.4,0,2.7,0.8,3.2,2.1l4.3-0.5v-0.2c0-1.9,1.6-3.5,3.5-3.5c0.7,0,1.3,0.2,1.8,0.5
			L33.4,5C33.1,4.5,33,4,33,3.5C33,1.6,34.6,0,36.5,0C38.4,0,40,1.6,40,3.5S38.4,7,36.5,7c-0.7,0-1.3-0.2-1.8-0.6l-6.1,5.5
			c0.3,0.5,0.4,1,0.4,1.5c0,1.9-1.6,3.5-3.5,3.5c-1.2,0-2.2-0.6-2.8-1.4L17.9,16c-0.3,1.7-1.7,2.9-3.4,2.9c-1,0-1.9-0.4-2.5-1
			L7,20.6z M38,3.5C38,2.7,37.3,2,36.5,2C35.7,2,35,2.7,35,3.5S35.7,5,36.5,5C37.3,5,38,4.3,38,3.5z M27,13.5c0-0.8-0.7-1.5-1.5-1.5
			c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5C26.3,15,27,14.3,27,13.5z M16,15.5c0-0.8-0.7-1.5-1.5-1.5S13,14.7,13,15.5
			s0.7,1.5,1.5,1.5S16,16.3,16,15.5z M5,20.5C5,19.7,4.3,19,3.5,19S2,19.7,2,20.5C2,21.3,2.7,22,3.5,22S5,21.3,5,20.5z"/>
		<path class="st0" d="M33,19.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.5-3.5,3.5c-1.2,0-2.2-0.5-2.8-1.4L29,23.3
			v0.2c0,1.9-1.6,3.5-3.5,3.5c-0.7,0-1.4-0.3-2-0.7l-5.9,5.6c0.3,0.5,0.4,1,0.4,1.6c0,1.9-1.6,3.5-3.5,3.5c-1.3,0-2.4-0.7-3-1.8
			l-4.5,1v0.3C7,38.4,5.4,40,3.5,40S0,38.4,0,36.5C0,34.6,1.6,33,3.5,33c1.1,0,2.1,0.5,2.7,1.4l4.8-1.1c0.2-1.9,1.7-3.3,3.5-3.3
			c0.6,0,1.2,0.2,1.7,0.5l6-5.7c-0.1-0.4-0.2-0.9-0.2-1.3c0-1.9,1.6-3.5,3.5-3.5c1.1,0,2.2,0.5,2.8,1.4l4.7-1.7V19.5z M2,36.5
			C2,37.3,2.7,38,3.5,38S5,37.3,5,36.5S4.3,35,3.5,35S2,35.7,2,36.5z M13,33.5c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5
			S15.3,32,14.5,32S13,32.7,13,33.5z M24,23.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5
			C24.7,22,24,22.7,24,23.5z M35,19.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5C35.7,18,35,18.7,35,19.5z
			"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Revenue
};
